"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandClient_1 = __importDefault(require("../GraphandClient"));
const GraphandModelList_1 = __importDefault(require("../lib/GraphandModelList"));
function hydrateModel(input, data, upsert = false) {
    data = data !== null && data !== void 0 ? data : {};
    const client = input instanceof GraphandClient_1.default ? input : input._client;
    const Model = (data.__scope ? (client === null || client === void 0 ? void 0 : client.getModel(data.__scope)) || input : input);
    switch (data.__type) {
        case "GraphandModelList":
            const list = GraphandModelList_1.default.hydrate(data, Model);
            upsert && Model.upsertStore(list);
            return list;
        case "GraphandModel":
            const instance = new Model(data.__payload);
            upsert && Model.upsertStore([instance]);
            return instance;
        default:
            break;
    }
    if (Array.isArray(data)) {
        const rows = data.map((i) => new Model(i));
        const list = new GraphandModelList_1.default({ model: Model, rows });
        upsert && Model.upsertStore(list);
        return list;
    }
    else {
        const instance = new Model(data);
        upsert && Model.upsertStore([instance]);
        return instance;
    }
}
exports.default = hydrateModel;
